/**
 * 获取滚动条宽度
 * @returns {number}
 */
function getScrollbarWidth() {
  const container = document.createElement("div");
  document.body.appendChild(container);
  container.style.overflow = "scroll";
  const inner = document.createElement("div");
  container.appendChild(inner);
  const scrollbarWidth = container.offsetWidth - inner.offsetWidth;
  document.body.removeChild(container);
  return scrollbarWidth;
}

/**
 * @description 菜单下拉
 * @type {menuDropdown}
 */
const menuDropdown = class extends HTMLElement {
  constructor() {
    super();
    // 处理子元素
    const dropdownMenu = this.querySelectorAll("li");
    const dropdownContent = this.querySelectorAll(".right-content .item");
    let activeIndex = 0;
    dropdownMenu.forEach((item, index) => {
      item.addEventListener("mouseover", () => {
        if (index < dropdownContent.length) {
          // 处理li
          dropdownMenu[activeIndex].classList.remove("active");
          item.classList.add("active");
          dropdownContent[activeIndex].classList.remove("active");
          dropdownContent[index].classList.add("active");
          activeIndex = index;
        }
      });
    });

    //监听父元素变化
    const parentNode = this.parentNode;
    parentNode.addEventListener("mouseleave", () => {
      if (dropdownMenu[activeIndex]) {
        dropdownMenu[activeIndex].classList.remove("active");
      }
      if (dropdownContent[activeIndex]) {
        dropdownContent[activeIndex].classList.remove("active");
      }
      if (dropdownMenu[0]) {
        dropdownMenu[0].classList.add("active");
      }
      if (dropdownContent[0]) {
        dropdownContent[0].classList.add("active");
      }
      activeIndex = 0;
      document.body.style.overflow = "";
      // 恢复body滚动
      document.body.classList.remove("no-scroll");
      document.documentElement.style.setProperty("--scrollbar-width", "17px");
    });

    // 获得焦点禁止body滚动
    parentNode.addEventListener("mouseover", () => {
      const scrollbarWidth = getScrollbarWidth();

      document.documentElement.style.setProperty(
        "--scrollbar-width",
        scrollbarWidth + "px",
      );
      document.body.classList.add("no-scroll");

      // 判断是否粘性
      const isStickyHeader = document.querySelector(
        ".components-header[header-sticky]",
      );
      if (isStickyHeader) {
        this.style.top = parentNode.getBoundingClientRect().bottom - 1 + "px";
      } else {
        this.style.top =
          parentNode.offsetTop +
          parentNode.offsetHeight -
          document.documentElement.scrollTop -
          1 +
          "px";
      }
    });

    // 鼠标失去焦点事件  需要的时候开启
    const mask = this.querySelector(".mask");
    mask.addEventListener("mouseover", () => {
      parentNode.style.pointerEvents = "none";
    });
    mask.addEventListener("mouseout", () => {
      setTimeout(() => {
        parentNode.style.pointerEvents = "auto";
      }, 300);
    });
  }

};
if (!window.customElements.get("menu-dropdown")) {
  window.customElements.define("menu-dropdown", menuDropdown);
}

// 监听菜单栏展开与关闭的操作
window.addEventListener("header-toggle", (e) => {
  const modelMenuBox = document.querySelector(".model-menu");
  if (e.detail.open) {
    document.body.classList.add("no-scroll");
    modelMenuBox.classList.add("active");
    modelMenuBox.style.height =
      "calc(100vh - " +
      (modelMenuBox.parentNode.offsetTop +
        modelMenuBox.parentNode.offsetHeight -
        document.documentElement.scrollTop) +
      "px)";

    const isStickyHeader = document.querySelector(
      ".components-header[header-sticky]",
    );
    if (isStickyHeader) {
      modelMenuBox.style.top =
        modelMenuBox.parentNode.getBoundingClientRect().bottom + "px";
    } else {
      modelMenuBox.style.top =
        modelMenuBox.parentNode.offsetTop +
        modelMenuBox.parentNode.offsetHeight -
        document.documentElement.scrollTop +
        "px";
    }
  } else {
    document.body.classList.remove("no-scroll");
    modelMenuBox.classList.remove("active");
    modelMenuBox.style.top = -100 + "px";
  }
});

/**
 * 防抖函数
 * @param func
 * @param wait
 * @returns {(function(): void)|*}
 * @private
 */
function _debounce(func, wait) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}

/**
 * 重置手风琴
 */
function resetAccordion() {
  const accordionAll = document.querySelectorAll(
    ".model-menu .accordion.group",
  );
  accordionAll.forEach((item) => {
    item.open = false;
  });
}

/**
 * 处理移动端菜单栏展开与关闭事件
 * @type {Element}
 */

const modelMenuOpenEl = document.querySelector(
  ".components-header .header-toggle .open",
);
const modelMenuCloseEl = document.querySelector(
  ".components-header .header-toggle .close",
);

if (modelMenuOpenEl && modelMenuCloseEl) {
  modelMenuOpenEl.addEventListener("click", () => {
    modelMenuOpenEl.classList.remove("active");
    modelMenuCloseEl.classList.add("active");
    window.dispatchEvent(
      new CustomEvent("header-toggle", { bubbles: true, detail: { open: true } }),
    );
  });

  modelMenuCloseEl.addEventListener("click", () => {
    modelMenuCloseEl.classList.remove("active");
    modelMenuOpenEl.classList.add("active");
    window.dispatchEvent(
      new CustomEvent("header-toggle", {
        bubbles: true,
        detail: { open: false },
      }),
    );
    resetAccordion();
  });
}

/**
 * 窗口大小变化时，判断是否需要关闭窗口
 */
function updateSizeDisplay() {
  if (window.innerWidth >= 1200) {
    if (modelMenuCloseEl && modelMenuCloseEl.classList.contains("active")) {
      modelMenuCloseEl.classList.remove("active");
      modelMenuOpenEl.classList.add("active");
      window.dispatchEvent(
        new CustomEvent("header-toggle", {
          bubbles: true,
          detail: { open: false },
        }),
      );
    }
  }
}

//处理窗口大小变化的问题
window.addEventListener("resize", _debounce(updateSizeDisplay, 100));

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".model-menu .product-list-scoll.swiper").forEach((el) => {
    new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: el.querySelector(".swiper-button-prev"),
        nextEl: el.querySelector(".swiper-button-next"),
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });

  // 监听手风琴的展开与关闭事件，只允许展开一个
  const accordionAll = document.querySelectorAll(
    ".model-menu .accordion__content .accordion.group",
  );
  accordionAll.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (item.open) {
        accordionAll.forEach((subItem) => {
          if (subItem !== item) subItem.open = false;
        });
      }
    });
  });

  // 外层 accordion 展开时自动打开第一个内层
  document.querySelectorAll(".model-menu-wrapper > .accordion.group > summary").forEach((summary) => {
    summary.addEventListener("click", () => {
      const outer = summary.closest(".accordion.group");
      setTimeout(() => {
        if (!outer.open) return;
        const firstInner = outer.querySelector(".accordion__content .accordion.group");
        if (firstInner && !firstInner.open) firstInner.open = true;
      }, 0);
    });
  });

  // 产品卡片放大镜 hover 效果
  document.querySelectorAll(
    ".components-header .menu-dropdown-content .product-item .image",
  ).forEach((item) => {
    const magnifier = item.querySelector(".magnifier");
    if (magnifier) {
      item.addEventListener("mousemove", () => magnifier.classList.add("show"));
      item.addEventListener("mouseleave", () => magnifier.classList.remove("show"));
    }
  });

  // 站点选择显示关闭
  const marketDrawer = document.querySelector("we-drawer#navigation-market-drawer");
  const marketBtn = document.querySelector("#navigation-market-btn");
  const marketMobBtn = document.querySelector("#navigation-market-mob-btn");
  if (marketBtn && marketDrawer) marketBtn.addEventListener("click", () => marketDrawer.open());
  if (marketMobBtn && marketDrawer) marketMobBtn.addEventListener("click", () => marketDrawer.open());
});

window.customElements.get("menu-dropdown-link") ||
  window.customElements.define(
    "menu-dropdown-link",
    class extends HTMLElement {
      constructor() {
        super();
        const parentNode = this.parentNode;

        parentNode.addEventListener("mouseover", () => {
          const rect = parentNode.getBoundingClientRect();
          parentNode.style.setProperty("--top", `${rect.bottom}px`);
          parentNode.style.setProperty("--left", `${rect.left}px`);
          document.documentElement.style.setProperty("--scrollbar-width", getScrollbarWidth() + "px");
          document.body.classList.add("no-scroll");
        });

        parentNode.addEventListener("mouseleave", () => {
          document.body.classList.remove("no-scroll");
          document.documentElement.style.setProperty("--scrollbar-width", "17px");
        });

        const mask = this.querySelector(".mask");
        mask.addEventListener("mouseover", () => {
          parentNode.style.pointerEvents = "none";
        });
        mask.addEventListener("mouseout", () => {
          setTimeout(() => {
            parentNode.style.pointerEvents = "auto";
          }, 300);
        });
      }
    },
  );

